import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { IAddressAction, getData, selectItem, tabAction, hideAction, IAddressStoreState } from '@/redux/ui/address';

interface IProps {
    hideAction() :void;
    selectItem(index: number, k: number, code: number): void;
    tabAction(index: number): void;
    getData(pCode?: any, rating?: any): any;
    listPro: any[]; // 省列表
    listCity: any[]; // 市列表
    listDist: any[]; // 区列表
    cityIndex: number; // 市索引
    distIndex: number; // 区索引
    proIndex: number; // 省索引
    tabIndex: number;
    visible: boolean;
};

class Address extends React.Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
  }
  public componentDidMount() {
    this.props.getData();
  }

  public render() {
    const props = this.props;
    return (
      <div className={`ui-address ${props.visible ? 'active' : ''}`}>
        <div className="ui-address-content">
          <div className="ui-address-head">
            <p>选择地址</p>
            <span onClick={() => this.hideHandle()}>取消</span>
          </div>
          <div className="ui-address-dt">
            <div className="ui-address-tab">
              <span className={props.tabIndex === 0 ? 'active' : ''} onClick={() => this.tabHandle(0)}>{props.listPro[props.proIndex] ? props.listPro[props.proIndex].name : '请选择'}</span>
              { props.proIndex > -1 && props.tabIndex > 0 ? <span className={props.tabIndex === 1 ? 'active' : ''} onClick={() => this.tabHandle(1)}>{props.listCity[props.cityIndex] ? props.listCity[props.cityIndex].name : '请选择'}</span> : null }
              { props.cityIndex > -1 && props.tabIndex > 1 ? <span className={props.tabIndex === 2 ? 'active' : ''} onClick={() => this.tabHandle(2)}>{props.listDist[props.distIndex] ? props.listDist[props.distIndex].name : '请选择'}</span> : null }
            </div>
          </div>
          {
            props.tabIndex === 0 ?
            <div className="ui-address-dd">
              {
                props.listPro.map((v: any, k: number) => {
                  return (
                    <p className={`${props.proIndex === k ? 'active' : ''}`} key={`proItem-${v.id}`} onClick={() => this.selectItem(0, k, v.code)}>{v.name}</p>
                  )
                })
              }
            </div>
            : null
          }

          {
            props.tabIndex === 1 ?
            <div className="ui-address-dd">
              {
                props.listCity.map((v: any, k: number) => {
                  return (
                    <p className={`${props.cityIndex === k ? 'active' : ''}`} key={`cityItem-${v.id}`} onClick={() => this.selectItem(1, k, v.code)}>{v.name}</p>
                  )
                })
              }
            </div>
            : null
          }
          {
            props.tabIndex === 2 ?
            <div className="ui-address-dd">
              {
                props.listDist.map((v: any, k: number) => {
                  return (
                    <p className={`${props.distIndex === k ? 'active' : ''}`} key={`distItem-${v.id}`} onClick={() => this.selectItem(2, k, v.code)}>{v.name}</p>
                  )
                })
              }
            </div>
            : null
          }
        </div>
      </div>
    )
  }
  /**
   * [选择省市区]
   * [选择省市区]
   * @param index [索引] 0 省 1市 2 区
   * @param k [项索引]
   * @param code [父级code码]
   */
  private async selectItem(index: number, k: number, code: number) {
    this.props.selectItem(index, k, code);
    switch(index) {
      case 0:
        this.props.getData(code, 1);
      break;
      case 1:
        this.props.getData(code, 2);
      break;
      case 2:
      break;
    }
  }
  /**
   * [切换]
   * @param index 0 省 1 市 2 区
   */
  private tabHandle(index: number) {
    this.props.tabAction(index);
  }
  /**
   * [隐藏面板]
   */
  private hideHandle() {
    this.props.hideAction();
  }
}

const mapStateToProps = ( state: any ): IAddressStoreState => {
    return {
        ...state.uiAddressReducers
    };
};

const mapDispatchToProps = ( dispatch: Dispatch<IAddressAction> ) => {
    return bindActionCreators({ getData, selectItem, tabAction, hideAction }, dispatch);
};

export default connect( mapStateToProps, mapDispatchToProps )(Address);
